import { __awaiter } from '../../_virtual/_tslib.js';
import MyAlgoConnect from '@randlabs/myalgo-connect';
import { DynamicError } from '@dynamic-labs/utils';
import { AlgorandWalletConnector } from '../AlgorandWalletConnector.js';
import { MyAlgoSigner } from './myalgoSigner.js';

class MyAlgoWalletConnector extends AlgorandWalletConnector {
    constructor(opts) {
        super(Object.assign(Object.assign({}, opts), { cacheKey: 'myalgo' }));
        this.name = 'MyAlgo';
        this.canConnectViaCustodialService = true;
    }
    getClient() {
        if (!this.client) {
            this.client = new MyAlgoConnect();
        }
        return this.client;
    }
    getNetwork() {
        return __awaiter(this, void 0, void 0, function* () {
            return undefined;
        });
    }
    fetchPublicAddress() {
        return __awaiter(this, void 0, void 0, function* () {
            const currentAddress = yield this.cache.getCurrentAddress();
            if (currentAddress) {
                return currentAddress;
            }
            const accounts = yield this.getClient().connect({
                shouldSelectOneAccount: true,
            });
            if (!accounts.length) {
                return undefined;
            }
            const [{ address }] = accounts;
            yield this.cache.setCurrentAddress(address);
            return address;
        });
    }
    getSigner() {
        return __awaiter(this, void 0, void 0, function* () {
            const address = yield this.fetchPublicAddress();
            if (!address)
                throw new DynamicError('MyAlgo Wallet Connector - Not connected!');
            return new MyAlgoSigner(address, this.getClient());
        });
    }
    signMessage(messageToSign) {
        return __awaiter(this, void 0, void 0, function* () {
            const signer = yield this.getSigner();
            const signature = yield signer.signBytes(Buffer.from(messageToSign));
            return Buffer.from(signature).toString('hex');
        });
    }
}

export { MyAlgoWalletConnector };
